// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {useRef, useState, useTrackPopover} from '@supermove/hooks';

export interface PopoverType {
  key: string;
  ref: React.MutableRefObject<any>;
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  handleToggle: () => void;
}

const usePopover = ({
  name,
  enableTracking = false,
}: {name?: string; enableTracking?: boolean} = {}): PopoverType => {
  const ref = useRef();
  const [isOpen, setVisible] = useState(false);
  const trackEvent = useTrackPopover({name});
  const handleOpen = () => {
    // Using setTimeout(0) to ensure the event processing completes before opening the popover.
    // This fixes cases on mobile web where pressing the button to open the popover also sends
    // a press event to the container that causes the popover to immediately close.
    setTimeout(() => {
      setVisible(true);
      // note: this is a hack to deal with the fact that handleOpen gets called twice in many cases;
      // once when we want to open the popover, and once inside the popover after it has been opened.
      if (!isOpen && enableTracking) {
        trackEvent();
      }
    }, 0);
  };
  const handleClose = () => setVisible(false);
  const handleToggle = () => {
    // Using setTimeout(0) to ensure the event processing completes before toggling the popover.
    // This fixes cases on mobile web where pressing the button to toggle the popover also sends
    // a press event to the container that causes the popover to immediately close.
    setTimeout(() => {
      setVisible(!isOpen);
      if (enableTracking && !isOpen) {
        trackEvent();
      }
    }, 0);
  };

  return {
    key: `${_.startCase(name)}_${isOpen}`,
    ref,
    isOpen,
    handleOpen,
    handleClose,
    handleToggle,
  };
};

export default usePopover;
